document.documentElement.classList.replace('no-js','js');
(function(){
  try{
  var header=document.querySelector('.site-header');
  addEventListener('scroll',function(){if(header)header.classList.toggle('is-scrolled',scrollY>10)},{passive:true});
  function observeReveals(){
    var els=document.querySelectorAll('.reveal:not(.in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(el){el.classList.add('in')});return}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.08,rootMargin:'0px 0px -5% 0px'});
    els.forEach(function(el){io.observe(el)});
  }
  observeReveals();
  document.addEventListener('shopify:section:load',observeReveals);
  document.addEventListener('shopify:section:reorder',observeReveals);
  var mmenu=document.getElementById('MobileMenu');
  document.getElementById('BurgerM')?.addEventListener('click',function(){mmenu&&mmenu.classList.add('open')});
  document.getElementById('MobileClose')?.addEventListener('click',function(){mmenu&&mmenu.classList.remove('open')});
  var overlay=document.getElementById('Overlay');
  function openCart(){var d=document.getElementById('CartDrawer');if(d)d.classList.add('open');if(overlay)overlay.hidden=false}
  function closeCart(){var d=document.getElementById('CartDrawer');if(d)d.classList.remove('open');if(overlay)overlay.hidden=true;var sp=document.getElementById('SearchPanel');if(sp)sp.classList.remove('open')}
  function updateCounts(c){if(!c||typeof c.item_count==='undefined')return;document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=c.item_count})}
  function khMoney(cents){
    cents=Math.max(0,Math.round(cents||0));
    var fmt='';
    try{var h=document.getElementById('CartDrawer')||document.getElementById('MainCart');if(h&&h.dataset&&h.dataset.moneyFormat)fmt=h.dataset.moneyFormat}catch(e){}
    if(!fmt)fmt='${{amount}}';
    var m=fmt.match(/\{\{\s*(\w+)\s*\}\}/),type=m?m[1]:'amount',n=cents/100;
    function grp(s,sep){return String(s).replace(/\B(?=(\d{3})+(?!\d))/g,sep)}
    var out,p=n.toFixed(2).split('.');
    if(type==='amount_no_decimals')out=grp(Math.round(n).toString(),',');
    else if(type==='amount_with_comma_separator')out=grp(p[0],'.')+','+p[1];
    else if(type==='amount_no_decimals_with_comma_separator')out=grp(Math.round(n).toString(),'.');
    else if(type==='amount_with_apostrophe_separator')out=grp(p[0],"'")+ '.'+p[1];
    else out=grp(p[0],',')+'.'+p[1];
    return fmt.replace(/\{\{\s*\w+\s*\}\}/,out);
  }
  function setAmount(el,cents){if(!el)return;cents=Math.max(0,Math.round(cents||0));el.dataset.amount=String(cents);el.textContent=khMoney(cents)}
  function drawerSubtotal(){var d=document.getElementById('CartDrawer');return d?d.querySelector('[data-cart-subtotal]'):null}
  function pageSubtotal(){var m=document.getElementById('MainCart');return m?m.querySelector('[data-cart-subtotal]'):null}
  function paintShip(){
    var d=document.getElementById('CartDrawer');if(!d)return;
    var box=d.querySelector('[data-ship]');if(!box)return;
    var th=parseInt(box.dataset.shipThreshold||'0',10)||0;
    var bar=box.querySelector('[data-ship-bar]'),msg=box.querySelector('[data-ship-msg]');
    var sub=drawerSubtotal(),total=sub?(parseInt(sub.dataset.amount||'0',10)||0):0;
    if(th<=0||total<=0){if(bar)bar.style.width='0%';return}
    var rem=th-total;
    if(rem>0){if(msg)msg.textContent="You're "+khMoney(rem)+" away from free shipping";if(bar)bar.style.width=Math.min(100,Math.round(total*100/th))+'%'}
    else{if(msg)msg.textContent="You've unlocked free shipping";if(bar)bar.style.width='100%'}
  }
  function optDrawer(delta){var el=drawerSubtotal();if(!el)return;setAmount(el,(parseInt(el.dataset.amount||'0',10)||0)+delta);paintShip()}
  async function postChange(key,qty){var r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});return r.json()}
  function swapSection(html,sel){
    try{
      var tmp=document.createElement('div');tmp.innerHTML=html;
      var fresh=tmp.querySelector(sel),live=document.querySelector(sel);
      if(!fresh||!live)return false;
      var box=live.querySelector('.cart-items'),st=box?box.scrollTop:0;
      live.innerHTML=fresh.innerHTML;
      var nbox=live.querySelector('.cart-items');if(nbox)nbox.scrollTop=st;
      return true;
    }catch(e){return false}
  }
  async function refreshDrawer(){
    try{var r=await (await fetch(window.location.pathname+'?section_id=cart-drawer')).text();swapSection(r,'#CartDrawer')}catch(e){}
  }
  async function refreshCartPage(){
    try{var r=await (await fetch('/cart?section_id=main-cart')).text();swapSection(r,'#MainCart')}catch(e){}
  }
  async function resync(){try{var c=await (await fetch('/cart.js')).json();updateCounts(c)}catch(e){}await refreshDrawer()}
  var cartTargets={},cartTimers={};
  function paintRow(row,q){row.dataset.qty=String(q);var n=row.querySelector('[data-qty-num]');if(n)n.textContent=String(q);var unit=parseInt(row.dataset.price||'0',10)||0;var lp=row.querySelector('[data-line-price]');if(lp)lp.textContent=khMoney(unit*q)}
  function syncRow(key){
    if(cartTimers[key])clearTimeout(cartTimers[key]);
    cartTimers[key]=setTimeout(async function(){
      delete cartTimers[key];
      var q=cartTargets[key];delete cartTargets[key];
      if(typeof q==='undefined')return;
      try{var cart=await postChange(key,q);updateCounts(cart);await refreshDrawer()}catch(e){await resync()}
    },280);
  }
  document.querySelectorAll('[data-open-cart]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openCart()})});
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-close-cart]')){e.preventDefault();closeCart();return}
    var scope=e.target.closest('#CartDrawer');if(!scope)return;
    var row=e.target.closest('[data-key]');if(!row)return;
    var btn=e.target.closest('[data-dec],[data-inc],[data-remove]');if(!btn)return;
    e.preventDefault();
    var key=row.dataset.key;
    if(btn.hasAttribute('data-remove')){
      if(cartTimers[key]){clearTimeout(cartTimers[key]);delete cartTimers[key]}
      delete cartTargets[key];
      var rq=(parseInt(row.dataset.qty||'0',10)||0),ru=parseInt(row.dataset.price||'0',10)||0;
      optDrawer(-ru*rq);
      row.style.opacity='.4';row.style.pointerEvents='none';
      (async function(){try{var cart=await postChange(key,0);updateCounts(cart)}catch(e){}await refreshDrawer()})();
      return;
    }
    var base=(key in cartTargets)?cartTargets[key]:(parseInt(row.dataset.qty||'1',10)||1);
    var q=base+(btn.hasAttribute('data-inc')?1:-1);if(q<0)q=0;
    var unit=parseInt(row.dataset.price||'0',10)||0;
    cartTargets[key]=q;paintRow(row,q);optDrawer(unit*(q-base));syncRow(key);
  });
  if(overlay)overlay.addEventListener('click',closeCart);
  var spanel=document.getElementById('SearchPanel');
  document.querySelectorAll('[data-open-search]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();if(spanel)spanel.classList.add('open');if(overlay)overlay.hidden=false;var i=spanel&&spanel.querySelector('input');if(i)i.focus()})});
  document.getElementById('SearchClose')?.addEventListener('click',closeCart);
  document.querySelectorAll('[data-quick-add]').forEach(function(btn){btn.addEventListener('click',async function(){
    var id=btn.dataset.quickAdd; btn.disabled=true; var old=btn.textContent; btn.textContent='Adding…';
    try{
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(id),quantity:1})});
      var both=await Promise.all([(await fetch('/cart.js')).json(),(await fetch(window.location.pathname+'?section_id=cart-drawer')).text()]);
      updateCounts(both[0]);swapSection(both[1],'#CartDrawer');openCart();
    }catch(e){}
    btn.textContent=old;btn.disabled=false;
  })});
  var gpills=document.querySelector('[data-gift-pills]');
  if(gpills){
    var gprice=document.querySelector('[data-gift-price]'),gadd=document.querySelector('[data-gift-add]');
    gpills.addEventListener('click',function(e){
      var b=e.target.closest('[data-variant]');if(!b)return;
      gpills.querySelectorAll('[data-variant]').forEach(function(x){x.classList.remove('is-active')});
      b.classList.add('is-active');
      if(gprice)gprice.textContent=khMoney(parseInt(b.dataset.price||'0',10));
      if(gadd)gadd.dataset.giftAdd=b.dataset.variant;
    });
    if(gadd)gadd.addEventListener('click',async function(){
      var id=parseInt(gadd.dataset.giftAdd||'0',10);if(!id)return;
      gadd.disabled=true;var old=gadd.textContent;gadd.textContent='Adding…';
      try{
        await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})});
        var both=await Promise.all([(await fetch('/cart.js')).json(),(await fetch(window.location.pathname+'?section_id=cart-drawer')).text()]);
        updateCounts(both[0]);swapSection(both[1],'#CartDrawer');openCart();
      }catch(e){}
      gadd.textContent=old;gadd.disabled=false;
    });
  }
  document.addEventListener('change',function(e){
    if(!e.target.closest)return;
    var inp=e.target.closest('#MainCart [data-cart-qty]');if(!inp)return;
    var q=Math.max(0,parseInt(inp.value||'0',10)||0);inp.value=String(q);inp.disabled=true;
    var prow=inp.closest('.cart-item'),unit=prow?(parseInt(prow.dataset.price||'0',10)||0):0;
    var prev=parseInt(inp.defaultValue||'0',10)||0;
    if(prow){var lpe=prow.querySelector('[data-line-price]');if(lpe)lpe.textContent=khMoney(unit*q)}
    var pse=pageSubtotal();if(pse)setAmount(pse,(parseInt(pse.dataset.amount||'0',10)||0)+unit*(q-prev));
    (async function(){try{var cart=await postChange(inp.dataset.key,q);updateCounts(cart);await refreshCartPage()}catch(e){inp.disabled=false}})();
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest)return;
    var btn=e.target.closest('#MainCart [data-cart-remove]');if(!btn)return;
    e.preventDefault();btn.disabled=true;
    var row=btn.closest('.cart-item');if(row)row.style.opacity='.4';
    var runit=row?(parseInt(row.dataset.price||'0',10)||0):0;
    var rqi=row?row.querySelector('[data-cart-qty]'):null,rq=rqi?(parseInt(rqi.value||'0',10)||0):0;
    var rse=pageSubtotal();if(rse)setAmount(rse,(parseInt(rse.dataset.amount||'0',10)||0)-runit*rq);
    (async function(){try{var cart=await postChange(btn.dataset.key,0);updateCounts(cart)}catch(e){}await refreshCartPage()})();
  });
  var slides=[...document.querySelectorAll('.q-slide')];var qi=0;
  function showQ(n){if(!slides.length)return;qi=(n+slides.length)%slides.length;slides.forEach(function(s,i){s.hidden=i!==qi})}
  document.getElementById('QPrev')?.addEventListener('click',function(){showQ(qi-1)});
  document.getElementById('QNext')?.addEventListener('click',function(){showQ(qi+1)});
  showQ(0);
  var sinput=document.getElementById('SearchInput'),sres=document.getElementById('SearchResults');
  var t; if(sinput)sinput.addEventListener('input',function(){clearTimeout(t);var q=sinput.value.trim();if(q.length<2){if(sres)sres.innerHTML='';return}t=setTimeout(async function(){try{var r=await (await fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,article&resources[limit]=4')).json();var h='';(r.resources?.results?.products||[]).forEach(function(p){h+='<a href="'+p.url+'" style="display:flex;gap:12px;align-items:center;padding:10px 0;border-bottom:1px solid #E2D9CB"><span><strong>'+p.title+'</strong></span></a>'});if(sres)sres.innerHTML=h||'<p style="color:#716C63">No results yet — try facial, body, hair…</p>'}catch(e){}},250)});
  var sticky=document.getElementById('StickyAtc');addEventListener('scroll',function(){if(sticky)sticky.classList.toggle('show',scrollY>600)},{passive:true});
  function openImageModal(){var g=document.querySelector('[data-gallery]');if(g&&g._openLb)g._openLb(0)}
  window.openImageModal=openImageModal;
  /* ---------- cookie consent (isolated: never blocks theme JS) ---------- */
  var khSafeStore=function(key,opts){
    var mem=null;
    opts=opts||{};
    function store(){try{return window.localStorage}catch(e){return null}}
    return{
      get:function(){try{var s=store();var raw=s?s.getItem(key):(mem&&mem[key]);if(!raw)return null;var v=JSON.parse(raw);return(v&&typeof v==='object')?v:null}catch(e){return null}},
      set:function(v){try{var s=JSON.stringify(v);var s2=store();if(s2)s2.setItem(key,s);else{mem=mem||{};mem[key]=s}}catch(e){try{mem=mem||{};mem[key]=JSON.stringify(v)}catch(_){}}}
    };
  };
  var khCookieStore=khSafeStore('kh_cookie_consent_v1');
  var khInitCookies=function(){
    try{
      var banner=document.getElementById('CookiesBanner');if(!banner||banner.dataset.kbInit)return;banner.dataset.kbInit='1';
      var prefs=document.getElementById('kb-prefs'),manage=document.getElementById('kb-manage');
      var accept=document.getElementById('kb-accept'),reject=document.getElementById('kb-reject'),save=document.getElementById('kb-save');
      function saved(){try{var s=khCookieStore.get();return !!(s&&typeof s.ts==='number')}catch(e){return false}}
      function show(){banner.classList.add('open')}
      function hide(){banner.classList.remove('open')}
      function store(v){try{khCookieStore.set({necessary:true,analytics:!!v.analytics,marketing:!!v.marketing,ts:Date.now()})}catch(e){}}
      if(accept)accept.addEventListener('click',function(){store({analytics:true,marketing:true});hide()});
      if(reject)reject.addEventListener('click',function(){store({analytics:false,marketing:false});hide()});
      if(manage&&prefs)manage.addEventListener('click',function(){var willOpen=prefs.hidden;prefs.hidden=!willOpen;manage.setAttribute('aria-expanded',willOpen?'true':'false')});
      if(save)save.addEventListener('click',function(){var an=document.getElementById('kb-analytics'),mk=document.getElementById('kb-marketing');store({analytics:!!(an&&an.checked),marketing:!!(mk&&mk.checked)});hide()});
      if(!saved())setTimeout(show,1200);
      document.addEventListener('shopify:section:load',function(){if(!saved()&&!banner.classList.contains('open'))show()});
    }catch(e){}
  };
  try{khInitCookies()}catch(e){}
  /* ---------- product gallery + fullscreen lightbox ---------- */
  var reduceMotion=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer=window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches;
  function pauseSlideMedia(slide){
    if(!slide||!slide.querySelectorAll)return;
    slide.querySelectorAll('video').forEach(function(v){try{v.pause()}catch(e){}});
    slide.querySelectorAll('iframe').forEach(function(f){try{
      var s=f.getAttribute('src')||'';
      if(s.indexOf('youtube.com')>-1||s.indexOf('youtu.be')>-1){f.contentWindow.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}),'*')}
      else if(s.indexOf('vimeo.com')>-1||s.indexOf('player.vimeo')>-1){f.contentWindow.postMessage(JSON.stringify({method:'pause'}),'*')}
    }catch(e){}});
  }
  var lb=document.getElementById('ImageModal');
  function closeGalleryLightbox(){
    if(!lb)return;
    pauseSlideMedia(lb.querySelector('.lb-slide.is-active'));
    lb.classList.remove('open');document.body.style.overflow='';
  }
  window.closeGalleryLightbox=closeGalleryLightbox;
  function openGalleryLightbox(root,start){
    if(!lb||!root)return;
    var slides=[...root.querySelectorAll('.gal-slide')];
    if(!slides.length)return;
    var track=lb.querySelector('[data-lb-track]'),thumbs=lb.querySelector('[data-lb-thumbs]'),count=lb.querySelector('[data-lb-count]');
    if(!track)return;
    track.innerHTML='';if(thumbs)thumbs.innerHTML='';
    var n=slides.length,cur=0;
    slides.forEach(function(s,k){
      var d=document.createElement('div');d.className='lb-slide';d.setAttribute('role','group');d.setAttribute('aria-label','Image '+(k+1)+' of '+n);
      if(s.dataset.type==='image'){
        var src=s.dataset.full||((s.querySelector('img')||{}).src)||'';
        var im=document.createElement('img');im.alt=((s.querySelector('img')||{}).alt)||'';im.dataset.full=src;im.decoding='async';
        d.appendChild(im);
      }else{d.appendChild(s.cloneNode(true));var b=d.querySelector('.gal-badge');if(b)b.remove()}
      track.appendChild(d);
      if(thumbs){
        var t=document.createElement('button');t.type='button';t.className='lb-thumb';t.setAttribute('aria-label','View image '+(k+1));
        var piv=s.querySelector('img');
        if(piv){var ti=document.createElement('img');ti.src=piv.currentSrc||piv.src;ti.alt='';ti.loading='lazy';t.appendChild(ti)}
        if(s.dataset.type!=='image'){var bd=document.createElement('span');bd.className='thumb-badge';bd.setAttribute('aria-hidden','true');bd.textContent='▶';t.appendChild(bd)}
        (function(idx){t.addEventListener('click',function(){show(idx)})})(k);
        thumbs.appendChild(t);
      }
    });
    function load(k){var sl=track.children[k];if(!sl||sl.dataset.done)return;sl.dataset.done='1';var im=sl.querySelector('img');if(im&&im.dataset.full)im.src=im.dataset.full}
    function show(k){
      pauseSlideMedia(track.children[cur]);cur=((k%n)+n)%n;
      track.style.transform='translateX('+(-cur*100)+'%)';
      [...track.children].forEach(function(sl,j){sl.classList.toggle('is-active',j===cur)});
      if(thumbs)[...thumbs.children].forEach(function(th,j){th.classList.toggle('is-active',j===cur);if(j===cur&&th.scrollIntoView)th.scrollIntoView({block:'nearest',inline:'nearest'})});
      if(count)count.textContent=(cur+1)+' / '+n;
      load(cur);load((cur+1)%n);load((cur-1+n)%n);
    }
    lb._go=function(d){show(cur+d)};
    show(start||0);
    lb.classList.add('open');document.body.style.overflow='hidden';
    var c=document.getElementById('ModalClose');if(c)c.focus({preventScroll:true});
  }
  document.querySelectorAll('[data-gallery]').forEach(function(root){
    var track=root.querySelector('[data-track]'),viewport=root.querySelector('[data-viewport]');
    var slides=[...root.querySelectorAll('.gal-slide')];
    if(!track||!viewport||!slides.length)return;
    var thumbs=[...root.querySelectorAll('[data-thumbs] .gal-thumb')];
    var dots=[...root.querySelectorAll('[data-dots] .gal-dot')];
    var countNow=root.querySelector('[data-count-now]');
    var n=slides.length,cur=0;
    slides.forEach(function(s,k){if(s.classList.contains('is-active'))cur=k});
    function clearZoom(){root.querySelectorAll('.gal-slide img.gal-img').forEach(function(im){im.style.transform='';im.style.transformOrigin=''})}
    function paint(){
      track.style.transform='translateX('+(-cur*100)+'%)';
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===cur);s.setAttribute('aria-hidden',k===cur?'false':'true')});
      thumbs.forEach(function(t,k){var on=(k===cur)||(k===thumbs.length-1&&cur>k);t.classList.toggle('is-active',on);if(on){t.setAttribute('aria-current','true');if(t.scrollIntoView)t.scrollIntoView({block:'nearest',inline:'nearest'})}else{t.removeAttribute('aria-current')}});
      dots.forEach(function(d,k){d.classList.toggle('is-active',k===cur)});
      if(countNow)countNow.textContent=cur+1;
    }
    function go(k){k=((k%n)+n)%n;if(k===cur)return;pauseSlideMedia(slides[cur]);cur=k;clearZoom();paint()}
    track.classList.add('no-anim');paint();requestAnimationFrame(function(){requestAnimationFrame(function(){track.classList.remove('no-anim')})});
    root.querySelectorAll('[data-prev]').forEach(function(b){b.addEventListener('click',function(){go(cur-1)})});
    root.querySelectorAll('[data-next]').forEach(function(b){b.addEventListener('click',function(){go(cur+1)})});
    thumbs.forEach(function(t){t.addEventListener('click',function(){var k=parseInt(t.dataset.index,10)||0;if(t.hasAttribute('data-more')&&root.dataset.lightbox!=='false'){openGalleryLightbox(root,k);return}go(k)})});
    dots.forEach(function(d){d.addEventListener('click',function(){go(parseInt(d.dataset.index,10)||0)})});
    root.querySelectorAll('[data-zoom-open]').forEach(function(b){b.addEventListener('click',function(){if(root.dataset.lightbox!=='false')openGalleryLightbox(root,cur)})});
    root._openLb=function(k){if(root.dataset.lightbox!=='false')openGalleryLightbox(root,k||0)};
    var sx=0,sy=0,dx=0,dy=0,touching=false,swiped=false;
    viewport.addEventListener('touchstart',function(e){if(e.touches.length>1){touching=false;return}touching=true;var t=e.touches[0];sx=t.clientX;sy=t.clientY;dx=dy=0},{passive:true});
    viewport.addEventListener('touchmove',function(e){if(!touching||e.touches.length>1){touching=false;return}var t=e.touches[0];dx=t.clientX-sx;dy=t.clientY-sy;if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>10)e.preventDefault()},{passive:false});
    viewport.addEventListener('touchend',function(){if(!touching)return;touching=false;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){swiped=true;go(cur+(dx<0?1:-1));setTimeout(function(){swiped=false},350)}});
    viewport.addEventListener('click',function(e){
      if(root.dataset.lightbox==='false')return;
      if(swiped){swiped=false;return}
      if(e.target.closest('button,video,iframe,audio,model-viewer'))return;
      openGalleryLightbox(root,cur);
    });
    if(root.dataset.zoom!=='false'&&finePointer&&!reduceMotion){
      slides.forEach(function(s){if(s.dataset.type==='image')s.setAttribute('data-zoomable','')});
      viewport.addEventListener('mousemove',function(e){
        var s=slides[cur];if(!s||s.dataset.type!=='image')return;
        var im=s.querySelector('img');if(!im)return;
        var r=viewport.getBoundingClientRect();
        im.style.transformOrigin=(((e.clientX-r.left)/r.width)*100).toFixed(1)+'% '+(((e.clientY-r.top)/r.height)*100).toFixed(1)+'%';
        im.style.transform='scale(1.9)';
      });
      viewport.addEventListener('mouseleave',clearZoom);
    }
    var sec=root.closest('.main-product');
    var vsel=sec&&sec.querySelector('select[name="id"]');
    if(vsel)vsel.addEventListener('change',function(){
      var opt=vsel.options[vsel.selectedIndex];var mid=opt&&opt.getAttribute('data-media');
      if(!mid)return;
      for(var k=0;k<slides.length;k++){if(slides[k].dataset.mediaId===mid){go(k);break}}
    });
  });
  if(lb){
    var mc2=document.getElementById('ModalClose');if(mc2)mc2.addEventListener('click',closeGalleryLightbox);
    lb.querySelectorAll('[data-lb-prev]').forEach(function(b){b.addEventListener('click',function(){if(lb._go)lb._go(-1)})});
    lb.querySelectorAll('[data-lb-next]').forEach(function(b){b.addEventListener('click',function(){if(lb._go)lb._go(1)})});
    var stage=lb.querySelector('[data-lb-stage]');
    if(stage){
      var lx=0,ldx=0,lt=false,lsw=false;
      stage.addEventListener('touchstart',function(e){if(e.touches.length>1){lt=false;return}lt=true;lx=e.touches[0].clientX;ldx=0},{passive:true});
      stage.addEventListener('touchmove',function(e){if(!lt||e.touches.length>1){lt=false;return}ldx=e.touches[0].clientX-lx;if(Math.abs(ldx)>10)e.preventDefault()},{passive:false});
      stage.addEventListener('touchend',function(){if(!lt)return;lt=false;if(Math.abs(ldx)>40&&lb._go){lsw=true;lb._go(ldx<0?1:-1);setTimeout(function(){lsw=false},350)}});
    }
    document.addEventListener('keydown',function(e){
      if(!lb.classList.contains('open'))return;
      if(e.key==='Escape')closeGalleryLightbox();
      else if(e.key==='ArrowLeft'&&lb._go)lb._go(-1);
      else if(e.key==='ArrowRight'&&lb._go)lb._go(1);
    });
  }
  /* ---------- homepage hero video stories ---------- */
  function initHeroVideo(){
    document.querySelectorAll('[data-hero]').forEach(function(hero){
      if(hero.dataset.heroInit)return;hero.dataset.heroInit='1';
      var videos=[...hero.querySelectorAll('[data-hero-video]')];
      if(!videos.length)return;
      var reduceMotion=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(reduceMotion){videos.forEach(function(v){v.removeAttribute('autoplay');try{v.pause()}catch(e){}});return}
      var cards=[...hero.querySelectorAll('[data-hero-card]')];
      var btns=[...hero.querySelectorAll('[data-hero-select]')];
      var cur=0,auto=true,resumeT=null,failStreak=0,stallT=null,slideT=null;
      var copies=[...hero.querySelectorAll('[data-hero-copy]')];
      hero.classList.add('is-loading');
      function pauseOthers(except){videos.forEach(function(v){if(v!==except){try{v.pause()}catch(e){}}})}
      function pauseAuto(ms){auto=false;if(resumeT)clearTimeout(resumeT);if(ms)resumeT=setTimeout(function(){auto=true},ms)}
      function clearSlideTimers(){if(stallT){clearTimeout(stallT);stallT=null}if(slideT){clearTimeout(slideT);slideT=null}}
      function armSlideTimer(v){
        clearSlideTimers();
        var d=v.duration;
        if(!isFinite(d)||d<=0)d=8;
        slideT=setTimeout(function(){
          slideT=null;
          if(v!==videos[cur])return;
          if(auto&&videos.length>1){activate(cur+1)}else{playVideo(v,false)}
        },d*1000+8000);
      }
      function ensureSrc(v){
        if(!v.getAttribute('src')&&v.dataset.src){v.src=v.dataset.src}
      }
      function markFailed(v){
        if(!v.dataset.failed){
          var url=v.currentSrc||v.getAttribute('src')||v.dataset.src||'(unknown source)';
          if(window.console&&console.error)console.error('[Kansa hero] Video failed to load, check the asset file: '+url);
          v.dataset.failed='1';
        }
        failStreak++;
      }
      function playVideo(v,advance,tries){
        tries=(typeof tries==='number')?tries:3;
        ensureSrc(v);
        function giveUp(){
          markFailed(v);
          if(advance&&auto&&videos.length>1&&failStreak<videos.length){activate(cur+1)}
          else if(failStreak>=videos.length){hero.classList.remove('is-loading')}
        }
        function go(){
          pauseOthers(v);
          try{v.currentTime=0}catch(e){}
          var pr=null;
          try{pr=v.play()}catch(e){pr=null}
          if(pr&&pr.then){
            pr.then(function(){failStreak=0;preloadNext()}).catch(function(){
              if(tries>1&&v===videos[cur]&&!v.dataset.failed){setTimeout(function(){if(v===videos[cur])playVideo(v,advance,tries-1)},600)}
              else giveUp();
            });
          }
        }
        if(v.dataset.failed){return}
        if(v.readyState>=2){go();return}
        var settled=false,timer=null;
        function cleanup(){if(timer)clearTimeout(timer);v.removeEventListener('canplay',ok);v.removeEventListener('error',no)}
        function ok(){if(settled)return;settled=true;cleanup();go()}
        function no(){if(settled)return;settled=true;cleanup();giveUp()}
        v.addEventListener('canplay',ok);
        v.addEventListener('error',no);
        timer=setTimeout(function(){if(!settled){settled=true;cleanup();giveUp()}},8000);
        try{v.load()}catch(e){no()}
      }
      function preloadNext(){
        try{
          var n=videos[(cur+1)%videos.length];
          if(n&&n!==videos[cur]&&!n.dataset.failed){
            if(!n.getAttribute('src')&&n.dataset.src){n.src=n.dataset.src}
            if(n.readyState<3){try{n.load()}catch(e){}}
          }
        }catch(e){}
      }
      function playCurrent(){playVideo(videos[cur],false)}
      function onStall(v){
        if(v!==videos[cur]||v.dataset.failed||stallT)return;
        stallT=setTimeout(function(){
          stallT=null;
          if(v!==videos[cur]||v.dataset.failed)return;
          playVideo(v,true,2);
        },4000);
      }
      function activate(i){
        if(i===cur)return;
        clearSlideTimers();
        videos[cur].classList.remove('is-active');
        if(cards[cur])cards[cur].classList.remove('is-active');
        if(copies[cur])copies[cur].classList.remove('is-active');
        if(btns[cur]){btns[cur].classList.remove('is-active');btns[cur].setAttribute('aria-selected','false')}
        cur=((i%videos.length)+videos.length)%videos.length;
        var v=videos[cur];
        hero.classList.add('is-loading');
        v.classList.add('is-active');
        if(cards[cur])cards[cur].classList.add('is-active');
        if(copies[cur])copies[cur].classList.add('is-active');
        if(btns[cur]){btns[cur].classList.add('is-active');btns[cur].setAttribute('aria-selected','true')}
        playVideo(v,true);
        armSlideTimer(v);
      }
      btns.forEach(function(b){b.addEventListener('click',function(){var i=parseInt(b.getAttribute('data-hero-select'),10)||0;pauseAuto(90000);if(i===cur){playVideo(videos[cur],false)}else{activate(i)}})});
      videos.forEach(function(v){
        v.addEventListener('ended',function(){if(v!==videos[cur])return;clearSlideTimers();if(auto&&videos.length>1){activate(cur+1)}else{playVideo(v,false)}});
        v.addEventListener('playing',function(){if(v!==videos[cur])return;failStreak=0;hero.classList.remove('is-loading');if(stallT){clearTimeout(stallT);stallT=null}});
        v.addEventListener('waiting',function(){onStall(v)});
        v.addEventListener('stalled',function(){onStall(v)});
        v.addEventListener('pause',function(){if(stallT){clearTimeout(stallT);stallT=null}});
      });
      document.addEventListener('visibilitychange',function(){if(document.hidden){try{videos[cur].pause()}catch(e){}}else if(auto){playCurrent()}});
      if('IntersectionObserver' in window){var heroIO=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){if(auto)playCurrent()}else{try{videos[cur].pause()}catch(e){}}})},{threshold:.12});heroIO.observe(hero)}
      playVideo(videos[0],true);
      armSlideTimer(videos[0]);
    });
  }
  try{initHeroVideo()}catch(e){}
  document.addEventListener('shopify:section:load',function(){try{initHeroVideo()}catch(e){}});
  /* Judge.me presence diagnostic — console only, renders nothing. Fires only when the
     review mount exists but is completely empty AND no Judge.me script is on the page,
     which means the app/embed/sync side needs attention (see console message). */
  try{
    var jwMount=document.getElementById('judgeme_product_reviews');
    if(jwMount){
      var jwCheck=function(){
        try{
          var hasContent=!!jwMount.querySelector('*');
          var hasScript=!!document.querySelector('script[src*="judge"]');
          if(!hasContent&&!hasScript&&window.console&&console.warn){
            console.warn('[Kansa Health] Judge.me did not render reviews: no Judge.me script detected. Install the Judge.me app, enable its App embed (Online Store > Themes > Customize > App embeds), and confirm this product is synced with published reviews in Judge.me.');
          }
        }catch(_){}
      };
      if(document.readyState==='complete'){setTimeout(jwCheck,4000)}
      else{addEventListener('load',function(){setTimeout(jwCheck,4000)})}
    }
  }catch(_){}
  }catch(e){console.warn(e);document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in')})}
})();
